

import { Inject, Injectable, InjectionToken } from '@angular/core'
import { BehaviorSubject } from 'rxjs';

import { BusinessThemeService, ITheme, IThemeService } from '../models'

import { CSSThemeService } from './theme.css.service';

export const USE_THEMES = new InjectionToken<ITheme[]>('USE_THEMES');

@Injectable({
	providedIn: 'root'
})
export class ThemeManagerService implements IThemeService {

	public static default = 'default'
	private _current$ = new BehaviorSubject(ThemeManagerService.default);
	public current$ = this._current$.asObservable();

	private backends: IThemeService[]

	constructor(
		@Inject(USE_THEMES) public themes: ITheme[] = [],
		cssThemeService?: CSSThemeService,
		businessThemeService?: BusinessThemeService,
	) {
		this.backends = <IThemeService[]>[
			cssThemeService,
			businessThemeService
		].filter(Boolean)

		this.install(...themes)
	}

	install(...themes: ITheme[]) {
		this.backends.forEach(b => b.install(...themes))
	}

	useTheme(themeId: string) {
		if (!this.themes.find(t => t.id === themeId)) {
			console.error(`[themes] No such theme "${themeId}"`)
			return
		}
		this._current$.next(themeId);
		this.backends.forEach(b => b.useTheme(themeId))
	}
}